module.exports = __webpack_public_path__ + "static/assets/a437d903d2c78e8bb8e29fc70c173f48.png";